import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { SettingsContext } from './settings-context';
import { AccountContext } from './account-context';
import { getTask, getAccount } from '../common/api-requests';
import { ErrorContext } from './error-context';

const SocketContext = createContext();

const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [settings, setSettings] = useContext(SettingsContext);
  const [account, setAccount] = useContext(AccountContext);
  const [isConnecting, setIsConnecting] = useState(false); // Track connection attempts
  const [error, setError] = useContext(ErrorContext);

  const socketRef = useRef(null);

  const initSocket = () => {
    if (socketRef.current) {
      socketRef.current.close();
    }

    socketRef.current = new WebSocket(settings.socketUrl);

    socketRef.current.onopen = () => {
      setIsConnecting(false); // Successfully connected
      setError(null);
      
      socketRef.current.send(JSON.stringify({ type: 1, data: `{ "Login": "+380${account.phone}", "Password": "${account.password}" }` }));
    };

    socketRef.current.onmessage = async (event) => {

      var responseFromServer = JSON.parse(event.data);

      if (!responseFromServer || !responseFromServer.Type)
        return;

      if (responseFromServer.Type == 2) {

        var data = JSON.parse(responseFromServer.Data)

        //PushType
        // Message = 1,
        // Form = 2,
        // Command = 3,
        // Recipient = 4

        //ActionType
        // Insert = 1,
        // Update = 2,
        // Delete = 3

        if (data && data.ID) {

          if (data.PushType == 1) {

            if (data.ActionType == 3) {
               setSocket({id: data.ID, type: 1, action: 3}); 
            }
            else if (data.ActionType == 2) {

              let message = await getTask(data.ID);

              if (!message)
                return;

              message.type = 1;
              message.action = 2;

              setSocket(message);
            }
            else {

              let message = await getTask(data.ID);

              if (!message)
                return;

              message.type = 1;
              message.action = 1;
              setSocket(message);
              
            }
          }
          else if (data.PushType == 2) {

          }
          else if (data.PushType == 3) {

          }
          else if (data.PushType == 4) {
            setSocket({id: data.ID, type: 4, action: data.ActionType});
          }
        }
      }
    };

    socketRef.current.onclose = (event) => {
      
      if (!event.wasClean && !isConnecting) {
        // An unexpected close, attempt to reconnect
        setError({isSocketError: true});
        setIsConnecting(true); // Prevent multiple reconnection attempts
        setTimeout(initSocket, 10000); // Reconnect after 10 seconds
      }
    };
  };

  useEffect(() => {
    if (settings && settings.socketUrl && account && account.phone && account.password) {
      initSocket();
    }
  }, [settings, account]);

  return (
    <SocketContext.Provider value={[socket, setSocket]}>
      {children}
    </SocketContext.Provider>
  );
};

export { SocketContext, SocketProvider };
